import { Box } from '@mui/material'
import * as React from 'react'
import { ReactNode } from 'react'

import {
  useLocationConfiguration,
} from "./LocationConfiguration";
import { AppBarSxBgcolor } from './pages/config/BrandingPage';

interface SearchBarContainerProps {
  children: ReactNode;
}

function SearchBarContainer({ children }: SearchBarContainerProps) {
  const { locationConfiguration } = useLocationConfiguration();

  const {
    appBarColor,
  } = locationConfiguration.pacSettings.displaySettings;

  return (
    <Box 
      sx={{
        // If we ever add support for dark mode we need a better way to solve this
        bgcolor: AppBarSxBgcolor[appBarColor],
        p: 2,
      }}
    >
      {children}
    </Box>
  );
}

export default SearchBarContainer;
